import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="app-footer" className="app-footer">
      <div className="footer-content">
        <div className="footer-section about-section">
          <h4>About Rec-Chord</h4>
          <p>Rec-Chord: A portmanteau of "record" and "recreational," symbolizing the creation of professional-quality transcripts with a recreational time commitment. "Chord" also references the key combinations used in stenography.</p>
          <p className="tagline">Your Voice, Perfectly Penned. No Experience Necessary.</p>
        </div>

        <div className="footer-section">
          <h4>Product</h4>
          <ul>
            <li><Link to="/plans-and-payment">Pricing</Link></li>
            <li><Link to="/dashboard">Dashboard</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact</h4>
          <p><a href="mailto:support@raindragon.ai">support@raindragon.ai</a></p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {currentYear} Rec-Chord. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
